<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/diRRQ1/tc-custom/9780823226771.jpg?1702083762025" alt="This image is the cover for the book Combat Reporter"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Combat Reporter
      </h1>
      <p class="bookDescription body article font2">
        <b>A Pulitzer Prize–winning combat correspondent recounts his personal experience of covering World War II on the front lines.</b><br/>  <br/> Legendary reporter Don Whitehead covered almost every important Allied invasion and campaign in Europe—from North Africa to landings in Sicily, Salerno, Anzio, and Normandy, and to the drive into Germany. His dispatches, published in <i>Beachhead Don</i>, are treasures of wartime journalism.<br/>  <br/> From September 1942, as a freshly minted Associated Press journalist in New York, to the spring of 1943 as Allied tanks closed in on the Germans in Tunisia, he also kept a diary of his experiences as a rookie combat reporter. The diary stops in 1943, and it has remained unpublished until now. Later, Whitehead started work on a memoir of his extraordinary life in combat that would remain unfinished.<br/>  <br/> In this book, John B. Romeiser has woven both the North African diary and Whitehead’s memoir of the subsequent landings in Sicily into a vivid, unvarnished, and completely riveting story of eight months during some of the most brutal combat of the war. Here, Whitehead captures the fierce fighting in the African desert and Sicilian mountains, as well as rare insights into the daily grind of reporting from a war zone, where tedium alternated with terror. These writings by two-time Pulitzer Prize winner offer a unique and up-close view of the Second World War—as well as a reminder of the risks journalist take to bring us the first draft of history.<br/>  <br/> “No one bore witness better than Don Whitehead . . . this volume, deftly combining his diary and a previously unpublished memoir, brings Whitehead and his reporting back to life, and twenty-first-century readers are the richer for it.” —from the foreword by Rick Atkinson
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Don Whitehead, John B. Romeiser
      </h2>
      
      <p class="authorDescription body article">Don Whitehead, who died in 1981, also worked for the New York Herald Tribune and the Knoxville News-Sentinel, won a George Polk Memorial Award, and wrote a number of books, including The FBI Story.John B. Romeiser teaches at the University of Tennessee, Knoxville, where he is founder and former director of the Normandy Scholars Program. He edited Beachhead Don: Reporting the War from the European Theater, 1942–1945 (Fordham).</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Fordham University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?49ab5e01